import { ButtonType, ButtonWidget } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '../../../codegen/Localize';

export interface NewExtractRefreshButtonProps {
  handleClick: () => void;
  disabled?: boolean;
}

export const NewExtractRefreshButton: React.SFC<NewExtractRefreshButtonProps>
    = (props: NewExtractRefreshButtonProps) => {
  return (
    <ButtonWidget
      children={Messages.newExtractRefresh()}
      buttonType={ButtonType.Outline}
      handleClick={props.handleClick}
      testId={'action-new-refresh-task'}
      disabled={props.disabled}/>
  );
};
